import { ActionTree } from 'vuex';
import { ConfigState } from './types';
import { StoreState } from '@/types';
// import { event } from 'vue-analytics';

const actions: ActionTree<ConfigState, StoreState> = {
  // before other modules
  // initPre({ state, dispatch, rootState, getters }) { },
  initPre() {
    // nothing
  },

  // after all other modules, might be that some config must be loaded only after logged in (scoped by account, etc)
  // initPost({ state, commit, getters }) {  },
  initPost() {
    // nothing
  },

};

export default actions;
